// @ts-nocheck

import { VIEWS } from "common";
import { CalendarCellProps } from "common/components/CalendarPro";
import { useEventEditorContext } from "features/events/Editor/EventEditorContext";
import StartBoatCellViewDay from "./StartBoatCellViewDay";
import StartBoatCellViewEdit from "./StartBoatCellViewEdit";
import StartBoatCellViewMonth from "./StartBoatCellViewMonth";
import StartBoatCellViewWeek from "./StartBoatCellViewWeek";
import useCell from "./useCell";

//export const CALENDAR_MONTH_CELL_WIDTH = "14.2857143%";
export const CALENDAR_MONTH_CELL_WIDTH = "14.25%";

export interface StartBoatCellProps
  extends CalendarCellProps<CalendarEventItem> {}
export default function StartBoatCell(props: StartBoatCellProps) {
  const { startTimes } = useCell(props);
  const { editMode, selectEvent, openModal } = useEventEditorContext();

  if (props.view && !!editMode) {
    return <StartBoatCellViewEdit startTimes={startTimes} {...props} />;
  }
  if (props.view && [VIEWS.DAY, VIEWS.AGENDA].includes(props.view)) {
    return <StartBoatCellViewDay startTimes={startTimes} {...props} />;
  }
  if (props.view && [VIEWS.WEEK].includes(props.view)) {
    return <StartBoatCellViewWeek startTimes={startTimes} {...props} />;
  }

  return <StartBoatCellViewMonth startTimes={startTimes} {...props} />;
}
